import { jsx } from 'react/jsx-runtime';
import { c as classNames } from '../../index-6ea95111.js';
import { s as styleInject } from '../../style-inject.es-1f59c1d0.js';

var css_248z = ".style-module_badge--small__cHO6v, .style-module_badge--medium__3CekE {\n  padding-bottom: 6px;\n  padding-top: 6px;\n}\n.style-module_badge--large__3_tWC {\n  padding-bottom: 8px;\n  padding-top: 8px;\n}";
var styles = {"badge--small":"style-module_badge--small__cHO6v","badge--medium":"style-module_badge--medium__3CekE","badge--large":"style-module_badge--large__3_tWC"};
styleInject(css_248z);

var getVariantClassNames = function (variant) { return ({
    information: 'bg-blue-100',
    neutral: 'bg-white',
    neutral200: 'bg-grey-200',
    neutral300: 'bg-grey-300',
    warning: 'bg-yellow-100',
    error: 'bg-red-100',
    success: 'bg-green-100',
    primary: 'bg-purple-100',
    primary900: 'bg-purple-900 tc-white',
}[variant]); };
var Badge = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.variant, variant = _d === void 0 ? 'information' : _d, children = _a.children;
    return (jsx("div", { role: "status", className: classNames(className, 'px16 br8 d-inline-block ai-center fw-bold p-p', { 'p-p--small': size === 'small' }, styles["badge--".concat(size)], getVariantClassNames(variant)), children: children }));
};

export { Badge };
//# sourceMappingURL=index.js.map
